<div class="card">
  <div class="card-header">
    RTPs
  </div>

  <div class="table-responsive">
    <table class="align-middle table table-borderless table-striped table-hover">
      <thead>
      <tr>
        <th scope="col"></th>
        <th>Generated by</th>
        <th>Period</th>
        <th>File</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let rtp of rtps | async | paginate: {itemsPerPage: 10, currentPage: p}">
        <th scope="row">
          <a class="mr-2" (click)="download(rtp.id)">
            <img src="assets/img/download.svg" tooltip="Download"></a>
        </th>
        <td>{{rtp.account_name}}</td>
        <td>{{rtp.period}}</td>
        <td>{{rtp.filename}}</td>
        <td>
          <button class="btn btn-success" (click)="openModal(rtp)">Send RTP for signing</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="d-block card-footer">
    <pagination-controls (pageChange)="p = $event"></pagination-controls>
  </div>
</div>
